<template>
    <div class="c-textarea">
        <textarea class="c-textarea__input" :placeholder="placeholder" v-model="value" v-on:change="$emit('changeText',value)"></textarea>
    </div>
</template>
<script>
export default {
    props:['placeholder'],
    data(){
        return {
            value:''
        }
    }
}
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-textarea{
        &__input{
            width: 100%;
            min-height: 20vh;
            border-radius: .5rem;
            border: 1px solid $gray;
            font-size: 1rem;
            padding: 1rem;
            font-family: 'Montserrat';
            &::placeholder{
                color: $black;
            }
        }
    }
</style>